class statisticsOpenedInvCtrl {
    constructor($scope, httpRequest) {
        // 用户信息
        const userInfo = JSON.parse(localStorage.user_info)
        // 存储页面信息
        $scope.pageState = {
            idToken: localStorage.id_token,
            userInfo,
        }

        // 字典数据
        $scope.dictData = {}
        let typecodeArr = ['inv_type', 'invoice_status', 'is_list', 'is_red', 'ovat_tax_rate', 'specific_element', 'source_object']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictionary = $.extend($scope.dictionary, res.data.value)
        })
    }
}
statisticsOpenedInvCtrl.$inject = ['$scope', 'httpRequest']
export default statisticsOpenedInvCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsOpenedInv/statisticsOpenedInvCtrl.js